import { render, staticRenderFns } from "./widget-bimList.vue?vue&type=template&id=518c3fda&scoped=true"
import script from "./widget-bimList.vue?vue&type=script&lang=js"
export * from "./widget-bimList.vue?vue&type=script&lang=js"
import style0 from "./widget-bimList.vue?vue&type=style&index=0&id=518c3fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518c3fda",
  null
  
)

export default component.exports